import React, { useState } from 'react';
import { useWebPush } from '../../hooks/useWebPush';
import { WEB_PUSH_STATE } from '../../utils/webPushState';
import {
  FALLBACK_KEYS,
  isStandalonePwa,
  readStored,
  writeStored,
} from '../../utils/foregroundFallback';
import '../NewViolationBanner/NewViolationBanner.css';

/**
 * Внутренний onboarding (PART 3, раздел 6).
 *
 * Системный prompt браузера появляется ТОЛЬКО после нажатия «Включить»: сам по
 * себе старт PWA его не вызывает. «Позже» запоминается, чтобы предложение не
 * возвращалось на каждом запуске.
 */
const PushOnboardingCardInner = () => {
  const { state, busy, enable } = useWebPush();
  const [dismissed, setDismissed] = useState(
    () => readStored(FALLBACK_KEYS.PUSH_ONBOARDING_DISMISSED) === 'true'
  );

  if (dismissed) return null;
  // PERMISSION_DEFAULT = push поддержан, разрешение браузера ещё не запрошено
  // (см. deriveWebPushState в utils/webPushState.js). NOT_SUBSCRIBED — это уже
  // выданное разрешение без подписки на бэкенде: пользователь, который только
  // что отключил push на этом устройстве, уговоры включить обратно получать
  // не должен, поэтому эту ветку сюда не добавляем.
  if (state !== WEB_PUSH_STATE.PERMISSION_DEFAULT) return null;

  const dismiss = () => {
    writeStored(FALLBACK_KEYS.PUSH_ONBOARDING_DISMISSED, 'true');
    setDismissed(true);
  };

  return (
    <div className="nvb nvb--onboarding" role="status">
      <span className="nvb-mark">!</span>
      <div className="nvb-text">
        <span className="nvb-title">Включить уведомления о нарушениях?</span>
        <span className="nvb-sub">Придут на это устройство, откроют карточку нарушения.</span>
      </div>
      <button type="button" className="nvb-open" disabled={busy} onClick={enable}>
        {busy ? 'Включаем…' : 'Включить'}
      </button>
      <button type="button" className="nvb-close" onClick={dismiss} aria-label="Позже">
        Позже
      </button>
    </div>
  );
};

/**
 * Обёртка для PushOnboardingCardInner, которая проверяет условия рендера до
 * вызова useWebPush(). Это предотвращает лишние запросы статуса push у
 * пользователей обычного браузера.
 */
const PushOnboardingCard = () => {
  const dismissed = readStored(FALLBACK_KEYS.PUSH_ONBOARDING_DISMISSED) === 'true';
  if (dismissed) return null;
  if (!isStandalonePwa()) return null;

  return <PushOnboardingCardInner />;
};

export default PushOnboardingCard;
